import { Checkbox, Heading, Paragraph, ValidationMessage } from '@digdir/designsystemet-react';
import { Fragment } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { OppvarmingFormData } from '../../../types';
import { CheckedContentWrapper, LeftBorderedContent } from '../common/styledComponents';
import { useOppvarmingValidation } from '../../hooks/useOppvarmingValidation';
import { oppvarmingSelectionFields } from '../../utils';

import { Elektrokjel } from './components/elektrokjel';
import { ElektrisitetCheckbox } from './components/elektrisitetCheckbox';
import { GulvvarmeCheckbox } from './components/gulvvarmeCheckbox';
import { Varmtvannsbereder } from './components/varmtvannsbereder';

export const Elektrisitet = () => {
  const { register, formState } = useFormContext<OppvarmingFormData>();
  const { t } = useTranslation('', { keyPrefix: 'form.oppvarming.elektrisitet' });
  const { validateOppvarmingSelection } = useOppvarmingValidation();

  // Common error and message for the whole group of checkboxes - we use the one from panelovn and show it once
  const elektrisitetSelectionError = formState.errors?.elektrisk?.value?.panelovn?.selected;

  const elektriskSelected = useWatch<OppvarmingFormData>({ name: 'elektrisk.selected' });
  const elektrisitetErrors = formState.errors?.elektrisk?.selected;

  return (
    <Fragment>
      <Checkbox
        aria-invalid={!!elektrisitetErrors}
        label={t('label')}
        {...register('elektrisk.selected', {
          validate: validateOppvarmingSelection,
          deps: oppvarmingSelectionFields,
          shouldUnregister: true
        })}
      />

      {elektriskSelected && (
        <CheckedContentWrapper>
          <LeftBorderedContent>
            <Heading level={3} data-size="2xs">
              {t('heading')}
            </Heading>
            <Paragraph>{t('description')}</Paragraph>
          </LeftBorderedContent>

          <ElektrisitetCheckbox name="panelovn" />
          <GulvvarmeCheckbox />
          <Elektrokjel />
          <ElektrisitetCheckbox name="luftvarme" description={t('luftvarme.description')} />
          <ElektrisitetCheckbox name="takvarme" description={t('takvarme.description')} />
          <Varmtvannsbereder />

          {elektrisitetSelectionError && (
            <LeftBorderedContent>
              <ValidationMessage>{t('error')}</ValidationMessage>
            </LeftBorderedContent>
          )}
        </CheckedContentWrapper>
      )}
    </Fragment>
  );
};
